import {mobileConfigurationEndpoint} from "../endpoints";

export const ListEndpoint = {
  all: mobileConfigurationEndpoint,
  create: mobileConfigurationEndpoint,
  zip: (id: number) => `${mobileConfigurationEndpoint}/${id}/zip`
};
